import * as React from "react";

import { DesignToken, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { ActionLink } from "components/links/ActionLink";
import { StyledLink } from "components/links/StyledLink";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { isInIframe } from "helpers/app";
import { getAppRootWithOrigin } from "helpers/url";
import { withVar } from "themes/helpers";

const url = "/settings/my-views";

const trackManageClick = (): void => {
  trackEngagement("Tickets: Manage ticket views clicked", EventPlace.Tickets);
};

const openExternalLink = (): void => {
  trackManageClick();
  window.open(`${getAppRootWithOrigin()}${url}`);
};

const MyViewsNavigationHeader: React.FC<{ canManage: boolean; title: string }> = ({ canManage }) => {
  const showExternalAppLink = isInIframe();

  return (
    <Flex justifyContent="space-between" paddingTop="30px" paddingBottom="10px" alignItems="center">
      <Text size="xs" uppercase bold customColor={withVar(DesignToken.ContentBasicDisabled)}>
        Ticket views
      </Text>
      {canManage &&
        (showExternalAppLink ? (
          <ActionLink onClick={openExternalLink} fontSize="13px">
            Manage
          </ActionLink>
        ) : (
          <StyledLink data-testid="manage-custom-views-ticket-list-button" to={url} onClick={trackManageClick}>
            Manage
          </StyledLink>
        ))}
    </Flex>
  );
};

export default MyViewsNavigationHeader;
